<div [class.fullscreen]="fullScreen" class="loading-container">
  <div class="spinner">
    <div class="dot dot1"></div>
    <div class="dot dot2"></div>
    <div class="dot dot3"></div>
  </div>
  <p class="message">{{ message }}</p>
</div>


